import { useContext } from 'react';

import { RootContext } from 'root/RootContext';

export function useCurrentUser() {
  const rootContext = useContext(RootContext);
  return rootContext.state.currentUser;
}

export function useAepSandboxes() {
  const rootContext = useContext(RootContext);
  return rootContext.state.myImsOrgs?.map((imsOrg) => imsOrg.aep)?.flat();
}

export function useAepSandbox(id) {
  const sandboxes = useAepSandboxes();
  return sandboxes.find((sandbox) => sandbox.id === id);
}

export function useAepSandboxSettings(id) {
  const sandbox = useAepSandbox(id);
  return sandbox?.imsOrg?.settings?.aep?.sandboxes?.find(
    (s) => s.name === sandbox.sandboxName
  );
}

export function useMarketoInstances() {
  const rootContext = useContext(RootContext);
  return rootContext.state.myImsOrgs?.map((imsOrg) => imsOrg.marketo)?.flat();
}

export function useActiveAep() {
  const rootContext = useContext(RootContext);
  return rootContext.state.activeAEP;
}
